<template>
  <div class="post">
    <div class="post__content">
      <div v-html="notification.action.meta.content"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      notification: { type: Object, required: true }
    }
  }
</script>


<style lang="scss" scoped>
  .post {
    &__content {
      ::v-deep {
        font-family: 'Poppins';
        color: #474747;

        h1, h2, h3 {
          font-weight: 700;
          padding: 4px 0;
        }

        h1 { font-size: 22px; line-height: 30px }
        h2 { font-size: 28px}
        h3 { font-size: 24px; color: #c1c1c1; font-weight: 500 }

        p { font-size: 16px; line-height: 24px; padding: 12px 0; letter-spacing: .5px; }

        img { width: auto; max-width: 100%; border-radius: 10px }

        a { color: #ff8000; &:hover { text-decoration: underline!important } }

        ul { 
          display: block;
          list-style-type: disc;
          margin-top: 1em;
          margin-bottom: 1em;
          margin-left: 0;
          margin-right: 0;
          padding-left: 20px;

          li {
            display: list-item;
            list-style-type: disc;
            font-weight: 500;
            padding: 2px 0;
          }
        }
      }
    }
  }
</style>